// Enable disabled link by...
// - Remove the state Class that disables the link, if any
// - Removing loader
function enableLink(link, linkDisabledClass, loaderClass){
  var ldrClass = (loaderClass) ? loaderClass : null;
  var lDsblClass = (linkDisabledClass) ? linkDisabledClass : 'is-loading';

  if(lDsblClass) link.classList.remove(lDsblClass);

  //currently only button has a nested loader
  if(link.classList.contains("button")) removeLoader(link, ldrClass);
}

// uses enable link
// we just send them an array of links
function enableLinks(linkArray, loaderClass, linkDisabledClass){
  var ldrClass = (loaderClass) ? loaderClass : null;
  var lDsblClass = (linkDisabledClass) ? linkDisabledClass : null;
  
  if(linkArray && linkArray.length>0){
    for(var i = 0; i < linkArray.length; i++){
      enableLink(linkArray[i], ldrClass, lDsblClass);
    }
  }
}